import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthRoutingModule} from './auth-routing.module';
import {SharedModule} from '../shared/shared.module';
import { AuthService } from '../services/auth-service/auth.service';
import { CachingService } from '../services/http-service/caching.service';
import { LoginModule } from './login/login.module';
import { AuthGuardService } from './auth-guard.service';
import { UsersService } from '../services/users-service/users.service';
import { AuthComponent } from './auth/auth.component';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule,
  ],
  providers: [
   CachingService,
   AuthGuardService,
  ],
  declarations: [AuthComponent]
})
export class AuthModule { }
